import { render, staticRenderFns } from "./examinationOptional.vue?vue&type=template&id=5b570a0c"
import script from "./examinationOptional.vue?vue&type=script&lang=js"
export * from "./examinationOptional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports